import { render } from "./SectorTypeSelector.vue?vue&type=template&id=ab70cbd4&scoped=true"
import script from "./SectorTypeSelector.vue?vue&type=script&lang=js"
export * from "./SectorTypeSelector.vue?vue&type=script&lang=js"

import "./SectorTypeSelector.vue?vue&type=style&index=0&id=ab70cbd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab70cbd4"]])

export default __exports__